import { render } from "./index.vue?vue&type=template&id=49088f20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-49088f20"

export default script